import 'moment/locale/es'; // without this line it didn't work

import { Browser } from '@capacitor/browser';
import React, { useState } from 'react';

function convertColor(hexColor: any) {
  // Check if the input string starts with "0xFF"
  if (hexColor.startsWith('0x')) {
    // Remove the "0xFF" prefix
    hexColor = hexColor.slice(4);
  }

  // Create a new string with "#" and the remaining characters
  const convertedColor = `#${hexColor}`;

  return convertedColor;
}
function convertFontSize(fontSize: any) {
  switch (fontSize) {
    case 'l':
      return '20px';
    case 'm':
      return '18px';
    case 's':
      return '16px';
    default:
      return '18px';
  }
}
function convertRadius(radius: any) {
  switch (radius) {
    case 'l':
      return '16px';
    case 'm':
      return '8px';
    case 's':
      return '0px';
    default:
      return '8px';
  }
}

const Text = ({ data }: any): JSX.Element => {
  const {
    alignment,
    fontColor,
    fontSize,
    text,
  } = data;

  return (
    <p style={{
      textAlign: alignment,
      color: convertColor(fontColor),
      fontSize: convertFontSize(fontSize),
    }}
    >
      {text}
    </p>
  );
};

const Buttons = ({ data }: any): JSX.Element => (
  <div style={{
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    marginTop: '8px',
  }}
  >
    {data.map((button: any) => {
      const {
        fontSize,
        fontColor,
        actionType,
        actionAndroid,
        backgroundColor,
        cornerRadius,
        text,
        id,
      } = button;
      return (
        <button
          key={id}
          type="button"
          style={{
            borderRadius: convertRadius(cornerRadius),
            fontSize: convertFontSize(fontSize),
            backgroundColor: convertColor(backgroundColor),
            color: convertColor(fontColor),
            padding: '12px',
            flex: 1,
          }}
          onClick={async () => {
            if (actionType === 'url') {
              if (actionAndroid.includes('http')) {
                await Browser.open({ url: actionAndroid });
              } else if (actionAndroid.includes('reporting') || actionAndroid.includes('formation') || actionAndroid.includes('profile')) {
                window.location.href = actionAndroid;
              }
            }
          }}
        >
          {text}
        </button>
      );
    })}
  </div>
);

const InAppWeb: React.FC<any> = ({ message }: any): JSX.Element => {
  const [show, setShow] = useState(true);

  const {
    backgroundColor,
    body,
    borderColor,
    borderWidth,
    buttonConfiguration,
    buttons,
    closeButton,
    cornerRadius,
    layoutOrder,
    media,
    title,
    type,
    windowColor,
  } = message;

  if (!show) return <></>;

  return (
    <div
      style={{
        position: 'absolute',
        top: '0',
        bottom: '0',
        left: '0',
        right: '0',
        backgroundColor: 'rgba(0,0,0, 0.50)',
        zIndex: 99999,
        maxWidth: 'unset',
      }}
      onClick={() => setShow(false)}
    >
      <div
        style={{
          backgroundColor: convertColor(backgroundColor),
          borderRadius: convertRadius(cornerRadius),
          position: 'relative',
          zIndex: 99999,
          padding: '16px',
          maxWidth: '400px',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
        }}
      >
        <img
          src={media.url}
          style={{
            margin: '0 auto 24px',
          }}
        />
        <Text data={title} />
        <Text data={body} />
        {buttons && <Buttons data={buttons} />}
      </div>
    </div>
  );
};

export default InAppWeb;
